/**
 * Разбор deep-link'ов уведомлений перед навигацией.
 *
 * Backend кладёт в уведомление относительный путь клиента (`/trash`, `/insights`,
 * `/ai-recognition/<id>`). React Router трактует любую строку как путь, поэтому внешний или
 * протокольный URL превратился бы в бессмысленный маршрут и увёл в NotFound — такие ссылки
 * отбрасываем и просто помечаем уведомление прочитанным.
 *
 * Устаревшие пути (например `/wardrobe/insights`, накопленный в БД до фикса) намеренно НЕ
 * фильтруются: их разруливают redirect-маршруты в `App.tsx` — так псевдонимы живут в одном месте,
 * рядом с таблицей маршрутов, и работают ещё и для прямого перехода по ссылке.
 */
export function resolveDeepLink(link?: string | null): string | null {
    if (!link) {
        return null;
    }
    const trimmed = link.trim();
    // Только относительный путь от корня; `//host` — протокольно-относительный внешний адрес.
    // Обратный слеш браузеры нормализуют в прямой: `/\evil.com` становится `//evil.com`.
    if (!trimmed.startsWith('/') || trimmed.startsWith('//') || trimmed.includes('\\')) {
        return null;
    }
    return trimmed;
}
